<template>
    <v-row justify="center" align="center" class="row">
      <MessageBox :message="messageBox.message" 
        :type="messageBox.tipoIcono" 
        :show="messageBox.mensajeVisible" 
        @closing="messageBox.mensajeVisible=false" />      
      <v-col
        cols="6"
        sm="12"
        md="6"
        xs="12"
        class="text-center"
      >
      <v-col cols="12">
        <v-btn icon title="Entidad" aria-label="Entidad">
            <v-icon 
                size="60">
                fas fa-clipboard-check
            </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="mt-1">
        <span
          class="font-weight-bold leading--text mb-3"
          :style="
            $vuetify.breakpoint.xs ? 'font-size: 25px' : 'font-size: 32px'
          "
        >Administración de una Entidad</span>
        <br />
        <!-- <span :class="$vuetify.breakpoint.xs ? 'font-weight-regular body-1' : 'font-weight-regular title'">Aqui encontrará la manera más fácil de consultar su proceso</span> -->

        <!-- <v-row>
        </v-row>-->
      </v-col>

        <v-form ref="form" class="my-2" v-model="entidad.valid" lazy-validation>
          <v-row>
            <v-col cols=12>
                <v-subheader class="v-subheader">
                    Datos Generales
                </v-subheader>
                <v-divider></v-divider>
            </v-col>  
            <v-col cols="6">
              <v-text-field
                v-model="entidad.entidad"
                label="* Entidad"
                required
                maxlength="100"
                :rules="entidadRules"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="entidad.dominio"
                label="* Dominio"
                required
                maxlength="50"
                :rules="dominioRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                clearable
                clear-icon="fas fa-time"
                v-model="entidad.observaciones"
                label="Observaciones"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols=12>
                <v-subheader class="v-subheader">
                    Configuración Seguimiento de Procesos
                </v-subheader>
                <v-divider></v-divider>
            </v-col>  
            <v-col cols="4">
              <v-text-field
                type="number"
                v-model="entidad.cantidadUsuarios"
                label="* Cantidad de Usuarios"
                :rules="cantidadUsuariosRules"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                type="number"
                v-model="entidad.procesosPorUsuario"
                label="* Procesos por Usuario"
                :rules="procesosPorUsuarioRules"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
                    <!-- :rules="[v => !!v || 'You must agree to receive!']" -->
                <v-checkbox
                    v-model="entidad.seguimientoConSnapShot"
                    label="seguimiento con SnapShots"
                ></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-text-field
                type="time"
                v-model="entidad.horaIni"
                label="Hora Ini"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                type="time"
                v-model="entidad.horaFin"
                label="Hora Fin"
                clearable
              ></v-text-field>
            </v-col>

          </v-row>
          <v-row>
            <v-col cols=12>
                <v-subheader class="v-subheader">
                    Datos de Contacto
                </v-subheader>
                <v-divider></v-divider>
            </v-col>  
            <v-col cols="6">
                    <!-- :rules="nameRules" -->
                <v-text-field
                    v-model="entidad.contactoNombres"
                    :rules="contactoNombresRules"
                    label="* Nombres"
                    maxlength="30"
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <!-- :rules="nameRules" -->
              <v-text-field
                v-model="entidad.contactoApellidos"
                :rules="contactoApellidosRules"
                label="* Apellidos"
                maxlength="30"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="entidad.contactoEMail"
                :rules="contactoEMailRules"
                type="email"
                label="* Email"
                maxlength="150"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="entidad.contactoTelefono"
                :rules="contactoTelefonolRules"
                label="* Telefono"
                maxlength="30"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="entidad.contactoCelular"
                :rules="contactoCelularRules"
                label="* Celular"
                maxlength="30"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-btn class="purple darken-2 white--text mt-5"  @click="submitForm"> 
            Register
          </v-btn>
          <v-btn class="purple darken-2 white--text mt-5"  @click="test"> 
            Test
          </v-btn> -->
        <div class="mt-n2 ">
          <v-btn
            :loading="loading"
            color="success"
            :class="
              `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
            "
            width="200"
            aria-label="Guardar cambios"
            @click="guardar"
            >Guardar</v-btn
          >
            <!-- dark -->
          <v-btn
            :class="
              `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
            "
            width="200"
            color="grey"
            @click="cancelar"
            aria-label="Cancelar cambios"
            >Cancelar</v-btn
          >
        </div>          
        </v-form>
      </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import MessageBox from "@/components/MessageBox.vue"

export default {
  components:{
    MessageBox
  },
  name: "MainAccesoEntidad",
  props:{
    id:{
      type: Number,
      default: 0
    }
  },  
  data: () => ({
    // idEntidad: '',
    messageBox: {
      message: '',
      tipoIcono:'info',
      mensajeVisible: false,
    },
    esNuevoEditar: false,
    loading: false,
    indiceEntidad: -1,
    entidad: {},
    // entidad :{
    //   entidad: 'JAAA',
    //   dominio: 'JUMM',
    //   observaciones: '',
    //   contactoNombres: '',
    //   contactoApellidos: '',
    //   contactoEMail: '',
    //   contactoTelefono: '',
    //   contactoCelular: '',
    //   cantidadUsuarios: '',
    //   procesosPorUsuario: '',
    //   seguimientoConSnapShot: ''
    // },
    entidadRules: [
      v => !!v || 'Es necesario ingresar el nombre de la entidad'
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    dominioRules: [
      v => !!v || 'El dominio es requerido'
    ],
    email: '',
    emailRules: [
      v => (v || '').length ===0 || /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) 
        || 'E-mail debe ser válido.',
    ],
    cantidadUsuariosRules: [
      v => !!v || 'Se requiere ingresar la cantidad de usuarios habilitados para la entidad.',
      v => Number(v) >=0 && Number(v) <= 2000  || 'La cantidad de ususarios ha de estar entre cero y 2000.'],
    procesosPorUsuarioRules: [
      v => !!v || 'Se requiere ingresar la cantidad máxima de procesos por usuario.',
      v => Number(v) >=0 && Number(v) <= 4000  || 'La cantidad máxima de procesos usuario ha de estar entre cero y 4000.'],
    contactoNombresRules: [
      v => !!v || 'Los nombres del contacto son requeridos'
    ],
    contactoApellidosRules: [
      v => !!v || 'Los apellidos del contacto son requeridos'
    ],
    contactoEMailRules: [
      v => !!v || 'El email del contacto es requerido',
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || "Ingrese un email válido.";
      },
    ],
    contactoTelefonolRules: [
      v => !!v || 'El teléfono del contacto es requerido'
    ],
    contactoCelularRules: [
      v => !!v || 'El celular del contacto es requerido'
    ],
  }),
  methods: {
    ...mapActions('acceso',['postEntidad','putEntidad']),   
    ...mapActions('process',['showNotifier']), 
    submitForm () {
      this.$refs.form.validate();
    },
    async guardar(){
      console.log("Entidades Guardando")
      try {
        this.loading=true
        // Si se cumplen las validaciones
        if (this.$refs.form.validate()) {
          console.log(this.entidad)
          // Guardar datos en el arreglo
          console.log('Entidad', this.entidad)
          
          if (this.esNuevoEditar){
            // // // this.$store.commit("acceso/setEntidadNva", this.entidad)
            await this.postEntidad(this.entidad)
          }
          else{
            // Colocar el índice del arreglo para cambiar sus datos
            this.$store.commit("acceso/setIndiceEntidad", this.indiceEntidad)

            console.log('Entidad Put', this.entidad)
            await this.putEntidad(this.entidad)
            // // this.$store.commit("acceso/setEntidad", this.entidad)
          }
          // Guardar datos en la BD

          // Regresar al listado
          this.$router.go(-1)
        } else {
          this.showNotifier({
            message: 'Hay datos que no son válidos, favor revisar, corregir e intentar nuevamente.',
            type: 'warning'
          });	
        }
      } finally {
        this.loading=false
      } 
       
    },
    cancelar(){
      // Regresar al listado
      this.$router.go(-1)
    },
    test(){
      console.log('Entidad',this.entidad.entidad)
      console.log('Dominio',this.entidad.dominio)
    }
  },
  created(){
    // Si se está modificando
    if (this.id){
      this.esNuevoEditar = false
      // Extraer los datos de la entidad
      
      const indiceEntidad = this.$store.state.acceso.entidades.findIndex(e=>e.idEntidad===this.id)
      
      if (indiceEntidad===-1){
        throw `No se encontró la entidad con id=${this.id}`
      }
      else{
        this.indiceEntidad = indiceEntidad
        this.entidad={...this.$store.state.acceso.entidades[indiceEntidad]}
      }
      console.log(this.entidad)
      
    // Si se está agregando
    }else{
       this.esNuevoEditar = true
    }
  }  
};
</script>
<style scoped>
  >>> .v-subheader {
     font-variant: small-caps; 
     font-weight: 300;
     color: darkgreen;
     /* border: solid;
     border-radius: 10px; */
  }
</style>